<template>
  <div class="flex flex-col gap-6">
    <jade-box :title="$t('terminal')">
      <template #action>
        <jade-dropdown
          v-if="canDoActionsTerminal"
          @toggleOpen="isOpen = !isOpen"
          :open="isOpen"
          data-testid="actionButton"
        >
          <template #trigger>
            <jade-action-button
              active
              dropdownIndicator
            >
              {{ $t('actions') }}
            </jade-action-button>
          </template>
          <jade-list-item
            :label="$t('request-paper-roll')"
            @onClick="$router.push({ name: terminalRollRequestRouteName })"
            as="button"
          />

          <jade-list-item
            :label="$t('terminal-replacement')"
            @onClick="
              $router.push({
                name: 'terminalSwap',
                params: { serialNumber: terminal.serial_number }
              })
            "
            as="button"
          />

          <jade-list-item
            :label="$t('terminal-uninstallation')"
            @keyup.page-down="terminalUninstallRoute()"
            @onClick="terminalUninstallRoute()"
            as="button"
          />
        </jade-dropdown>
      </template>
      <div
        v-if="loadingListTerminals"
        class="eu-pa_6 eu-align_center"
        data-testid="show-loading"
      >
        <emd-loader type="_invert"></emd-loader>
      </div>
      <div
        class="py-2"
        v-else
      >
        <Table
          :fields="fields"
          :items="[terminal]"
        />
      </div>
    </jade-box>

    <jade-box
      :title="$t('title')"
      hasPadding
    >
      <div
        v-if="loadingListTerminals"
        class="eu-pa_6 eu-align_center"
        data-testid="show-loading"
      >
        <emd-loader type="_invert"></emd-loader>
      </div>
      <form-shell
        v-else
        :formsOnShell="formsOnShell"
        onlyFields
        removePadding
      />
    </jade-box>

    <history-details
      :historyFields="historyFields"
      :loading="loadingListTerminals"
      title="terminal-history"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { JadeBox, JadeDropdown, JadeListItem, JadeActionButton } from '@jade'
import { EmdLoader } from 'emerald-vue/src/components'

import Table from '@/components/project/molecules/Table.vue'
import { TERMINAL_ROUTES_ENUM, STATUS_ENUM } from '@/enums/physical-world.enum'
import { physicalWorldCreateOrderEnabled } from '@/actions-permission/physical-world.permissions'
import FormShell from '@/views/PhysicalWorld/components/FormShell'

import HistoryDetails from '../components/HistoryDetails.vue'
import { TERMINAL_LIST_FIELDS } from './terminals-list.fields'

export default {
  name: 'TerminalDetails',
  components: {
    FormShell,
    Table,
    EmdLoader,
    JadeBox,
    JadeDropdown,
    JadeListItem,
    JadeActionButton,
    HistoryDetails
  },

  data () {
    return {
      isOpen: false,
      terminalUninstallRouteName: TERMINAL_ROUTES_ENUM.TERMINAL_UNINSTALL,
      terminalRollRequestRouteName: TERMINAL_ROUTES_ENUM.TERMINAL_ROLL_REQUEST
    }
  },

  computed: {
    ...mapGetters(['terminal', 'loadingListTerminals', 'permissionIsEnabled']),
    formsOnShell () {
      const { serial_number: serialNumber, store } = this.terminal
      return [
        {
          name: 'FormTerminalData',
          disabled: true,
          initialValues: {
            serialNumber
          },
          fields: ['serialNumber']
        },
        {
          name: 'FormAddress',
          searchZipCode: false,
          disabled: true,
          show: false,
          initialValues: {
            city: store?.address?.city,
            country: store?.address?.country,
            neighborhood: store?.address?.neighborhood,
            state: store?.address?.state,
            zip_code: store?.address?.zip_code,
            street: store?.address?.line1,
            complement: store?.address?.line2
          }
        }
      ]
    },
    historyFields () {
      return {
        title: this.$t('terminal-history'),
        activationCode: this.terminal.activation_code,
        createdAt: this.terminal.created_at,
        installedAt: this.terminal.installed_at,
        uninstalledAt: this.terminal.uninstalled_at,
        updatedAt: this.terminal.updated_at
      }
    },
    canDoActionsTerminal () {
      return (
        physicalWorldCreateOrderEnabled(this.permissionIsEnabled) &&
        STATUS_ENUM.INSTALLED === this.terminal.status
      )
    },
    fields () {
      return TERMINAL_LIST_FIELDS.map(item => ({
        ...item,
        label: this.$t(item.label),
        transform: status => {
          return status ? this.$t(status.toLowerCase()) : ''
        },
        type:
          typeof item.type === 'function' ? item.type(this.isLink) : item.type
      }))
    }
  },
  methods: {
    terminalUninstallRoute () {
      this.$router.push({
        name: this.terminalUninstallRouteName,
        params: { serialNumber: this.terminal.serial_number }
      })
    }
  }
}
</script>
<i18n>
  {
    "pt-BR": {
      "title": "Informações",
      "serial_number": "Número de série",
      "status": "Status",
      "model": "Modelo",
      "type": "Tipo",
      "connection": "Conexão",
      "terminals": "Maquininhas",
      "request_terminal": "Solicitar Maquininha",
      "installed": "Instalado",
      "uninstalled": "Desinstalado",
      "terminal": "Maquininha",
      "actions": "Ações",
      "request-paper-roll": "Solicitação de bobina",
      "terminal-replacement": "Substituição de maquininha",
      "terminal-uninstallation": "Desinstalação de maquininha",
      "terminal-history": "Histórico de Maquininha"
    },
    "en-US": {
      "title": "Details",
      "serial_number": "Serial Number",
      "status": "Status",
      "model": "Model",
      "type": "Type",
      "connection": "Connection",
      "terminals": "Terminals",
      "request_terminal": "Request Terminal",
      "installed": "Installed",
      "uninstalled": "Uninstalled",
      "terminal": "Terminal",
      "actions": "Actions",
      "request-paper-roll": "Paper roll request",
      "terminal-replacement": "Terminal replacement",
      "terminal-uninstallation": "Terminal uninstallation",
      "terminal-history": "Terminal History"
    }
  }
</i18n>

<style scoped>
.dropdown-custom :deep(.emd-dropdown__content) {
  display: none;
}
.dropdown-custom.open :deep(.emd-dropdown__content) {
  display: block;
}
</style>
